// Loops Configuration
// Toggle loops on/off to control what appears in the canvas

const loopsConfig = {
  territory: false,   // Left sidebar - file tree, external services, connections
  workflows: true,    // Workflow list and editor
  evaluators: false,  // Evaluation metrics and history
  chat: false,        // Chat interface for agent interactions
};

export default loopsConfig;
